<template>
    <Alert type="warning" @close="$emit('cancel')">
        <template v-slot:heading>
            You are about to log in as:<br>
            {{athleteName}}
        </template>

        <template v-slot:body>
            Any actions you take while logged in
            will be executed on behalf of this player.
            Would you like to continue?
        </template>

        <template v-slot:confirm>
            <Button text="Yes, Log In" color="blue" emphasis="high" @click="$emit('confirm')" />
        </template>
    </Alert>
</template>

<script>
import Alert from '@/components/SourAlert'
import { Button } from '@sportsrecruits/playbook'

export default {
    components: { Button, Alert },

    props: {
        athleteName: { type: String, required: true },
    }
}
</script>